import { Middleware } from "redux"
import RootState from "store/state"
import AnyAction from "store/anyActions"
import AppTypes from "store/app/app.types";
import UserTypes from "store/user/user.types";
import { reportIssue } from "services/api/api.company";
import { updateContactAttributes } from "services/api/api.contact";
import * as userActions from "store/user/user.actions";
import ContactTypes from "store/contact/contact.types";
import { ICallContactAttributes } from "store/contact/contact.state";
import { contactAttributes } from "store/contact/contact.utils";
import logger from 'logger';

//@ts-ignore
window.connect = connect

let w: Window | null;

//enforce v2
const getCCPURL = (ccpURL:string)=> !ccpURL.match(/connect\/ccp-v2/g) ? ccpURL.replace(/connect\/ccp/g,'connect/ccp-v2') : ccpURL;

function openCCPWindow(ccpURL: string) {
    const getTop = () => window.innerHeight / 2 - 290;
    const getLeft = () => window.innerWidth / 2 - 200;

    w = window.open(
        getCCPURL(ccpURL),
        'ccp',
        `toolbar=no,height=600,width=400,top=${getTop() + window.screenY},left=${getLeft() +
        window.screenX}`
    );
    if (w) {
        w.focus();
    }
}



const ccpAppMiddleware: Middleware<{}, RootState> = store => next => (action: AnyAction) => {

    if (store.getState().app?.callProvider === "kumodi") {
        return next(action);
    }

    switch (action.type) {
        case AppTypes.SELECT_INSTANCE:{
            const { instance, appConfig } = action.payload
            const app = document.getElementById('app');
            const ccpUrl = getCCPURL(instance.ccpURL);         
            connect.core.initCCP(app!, {
                ccpUrl,
                loginPopup: false,
                region: instance.region,
                softphone: {
                    allowFramedSoftphone: appConfig.allowFramedSoftphone ? true : false,
                },
                //@ts-ignore
                ccpAckTimeout: appConfig.ccpAckTimeout, //optional, defaults to 3000 (ms)
                //@ts-ignore
                ccpSynTimeout: appConfig.ccpSynTimeout, //optional, defaults to 1000 (ms)
                //@ts-ignore
                ccpLoadTimeout: appConfig.ccpLoadTimeout //optional, defaults to 5000 (ms)
            });



            connect.core.initSoftphoneManager({ allowFramedSoftphone: true });

            connect.core.onAccessDenied(function(){
                //This happens when a user does not have CCP:All set in connect - they are authenticated but we cannot load the user
                if(store.getState().auth.authenticated && !store.getState().user){
                    store.dispatch(userActions.authError('User does not have correct permissions'))
                }
            })
                
            connect.core.onAuthFail(()=> {
                store.dispatch({type:AppTypes.CCP_LOGOUT})
                setTimeout(() => {
                    window.location.reload();
                }, 500);
                })


            return next(action);
        }
        case UserTypes.AUTH_EXTERNAL_USER_REQUEST: {
            //Loggin in with cognito, ad etc, SA Api has returned us a token for CCP, we use it to login via our iframe
            const iframe = document.getElementById('sa-login-iframe') as HTMLIFrameElement;
            iframe.contentWindow!.postMessage(
                {
                    type: 'smartagent-login',
                    credentials: action.payload.credentials,
                    ccpURL: getCCPURL(action.payload.ccpURL),
                },
                '*'
            );
            return next(action);
        }

        case UserTypes.LOGIN: {
            const { instance, identityManagement } = store.getState().app;
            if (!instance) return next(action);

            if (identityManagement && identityManagement !== 'connect') {
                return next(action);
            }

            w ? w.focus() : openCCPWindow(instance.ccpURL);



            return next(action);
        }


        case UserTypes.REFRESH:
            store.dispatch(userActions.setAvailable());
            setTimeout(() => {
                //refresh the page
                window.location.href = '.';
            }, 1000);
            return next(action);

        case UserTypes.LOGOUT:{
            store.dispatch(userActions.setNotAvailable());
            const eventBus = connect.core.getEventBus();
            eventBus.trigger(connect.EventType.TERMINATED);
            connect.core.terminate();
          
            const url = store.getState().app.instance!.ccpURL;
            const iframe = document.querySelector('iframe[src="' + getCCPURL(url) + '"]') as HTMLIFrameElement;
            // The logout endpoint does not need ccp-v2connect
            const logoutUrl = (url.split('connect/')[0] + 'connect/logout').replace('ccp-v2connect/','')
            iframe.src = logoutUrl;
            
            setTimeout(() => {
                window.location.reload();
            }, 500);
            return next(action);
        }
        case UserTypes.USER_LOADED:
            w?.close();
            return next(action);

        case ContactTypes.UPDATE_CONTACT_ATTRIBUTES: {
            next(action);
            const { contact, app, auth, call, user, chat, tasks } = store.getState();

            if (!action.payload || (!contact?.ID && !action.payload?.ID)) return;
            //Don't update contact if we are not in a call or in after call work and not forcing the update
            if(!action.payload.commitUpdate) { 
                    if(contact?.channel === "VOICE" && !call && user.status.name !== 'AfterCallWork' ) return; 
                    if(contact?.channel === "CHAT" && !chat.connections.find(chat => contact.ID === chat.id)) return; 
                    if(contact?.channel === "TASK" && !tasks.connections.find(task => contact.ID === task.id)) return;
                }
            //Only certain fields will be updated on the CTR

            const updateFields = ['sa-acw-','sa-DPA', 'sa-cm-od-', ...contactAttributes, ...(app.appConfig.contactAttributes || [])];
            const attributes = Object.keys(action.payload.attributes).reduce((attributes: ICallContactAttributes, key: string) => {
                //Check for matches - can either start sa- or not eg ['externalID'] matches sa-externalID and externalID
                const hasMatches = updateFields.find(field => key.indexOf(field) === 0 || key.indexOf(field) === 3);
                if (hasMatches) {
                    attributes[key] = action.payload.attributes[key]?.toString();
                }
                return attributes;
            }, {} as ICallContactAttributes);

            if (!Object.keys(attributes).length) return;

            return updateContactAttributes(
                app.ID,
                app.instance!.ID,
                contact?.originalContactID || action.payload.ID,
                auth.token!,
                attributes
            ).catch();
        }

        case AppTypes.REPORT_ISSUE: {
            const state = store.getState();
            reportIssue(state.app.ID, {
                description: action.payload,
                state,
                //@ts-ignore
                // hacky fix for getting connect logs
                connectLogs: (connect.getLog() as any)._logs,
            }).then(() => {
                return next(action);
            });
            return;
        }

        default:
            return next(action);
    }

}


export default ccpAppMiddleware;